
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import StyleInjector from '@/components/StyleInjector.vue';
import AppFooter from '@/components/footer/AppFooter.vue';
import AppHeader from './components/nav/AppHeader.vue';

import { DeclareUserStats, useUserStats } from '@/helpers/composables/useUserStats';

const Experiments = () => import(/* webpackChunkName: "experiments" */ '@/components/experiments/Experiments.vue');
const LowPriorityComponents = () =>
	import(/* webpackChunkName: "low-priority-components" */ '@/components/LowPriorityComponents.vue');
const LoginFlow = () => import(/* webpackChunkName: "login-flow" */ '@/components/login/LoginFlow.vue');

import { CollectionType } from '@/enums/collection-type';

// @ts-ignore
import LazyHydrate from 'vue-lazy-hydration';
// @ts-ignore
import NoSSR from 'vue-no-ssr';

// make NoSSR a globaly available component
Vue.component('NoSSR', NoSSR);
Vue.component('LazyHydrate', LazyHydrate);

// AppFooter global to avoid CLS
Vue.component('AppFooter', AppFooter);

// SSR Content
import ContentSSR from '@/components/ContentSSR.vue';
// eslint-disable-next-line
Vue.component('Content', ContentSSR);

import '@/styles/global.scss';
import '@fortawesome/fontawesome-svg-core/styles.css';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import { enableScroll } from './helpers/scroll-helper';

const Language = namespace('language');
const Meta = namespace('meta');
const Routing = namespace('routing');
@Component({
	name: 'SSRApp',
	components: {
		AppHeader,
		Experiments,
		LowPriorityComponents,
		StyleInjector,
		LoginFlow,
	},
	metaInfo() {
		return this.head;
	},
	setup() {
		const { permanentAudiences } = useUserStats();
		return { permanentAudiences };
	},
})
export default class App extends Vue {
	@Language.Getter locale: string;
	@Meta.Getter head: any;
	@Routing.Getter lastActiveCollectionType: null | CollectionType;
	declare permanentAudiences: DeclareUserStats['permanentAudiences'];

	async mounted() {
		const { initStoreWatchers } = await import(/* webpackChunkName: "main.common" */ '@/main.common');
		initStoreWatchers(this.$context);

		const { initCoreWebVitalsMonitor } = await import('@/helpers/tracking/cwv-helper');
		initCoreWebVitalsMonitor();

		Vue.nextTick(() => {
			const int = setInterval(() => {
				// remove loader
				const loader = document.querySelector('#loader');
				loader?.parentNode?.removeChild(loader);
				clearInterval(int);
			}, 50);

			// reactivate scroll on page rendered
			enableScroll();
		});

		const { TrackingHelper } = await import('@/helpers/tracking/tracking-helper');
		TrackingHelper.isInitializedPromise.then(() =>
			TrackingHelper.refreshPermanentAudiences(this.permanentAudiences)
		);
	}

	get hideAppHeader() {
		return this.$route.name === 'app.streaming-charts';
	}
}
